module.exports = __webpack_public_path__ + "static/media/CAFE.1ab6cf99.jpg";